import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { resetAllCollections } from '../../slices/orderSlice';
import * as mapActions from '../../slices/mapSlice';
import * as searchActions from '../../slices/searchSlice';
import './MultiSearchView.css';
import Timeline from '../Timeline/Timeline';
import MinimizeIcon from "../../assets/images/svgs/MinimizeIcon.svg?react"
import MaximizeIcon from "../../assets/images/svgs/MaximizeIcon.svg?react"
import Close from "../../assets/images/svgs/Close.svg?react"
import SingleSelectDropdown from '../../common/utils/SingleSelectDropdown';
import { analysisOptions } from '../../common/constants/orderOptions.js'
import { getDraftOrders } from '../../services/orders.service.jsx';
import { PRIVATEER_REDIRECT_URL } from '../../common/utils/apiService.jsx';

const MultiSearchView = () => {
    const dispatch = useDispatch();
    const [isModalMinimized, setIsModalMinimized] = useState(false);
    const isLeftNavCollapsed = useSelector(state => state.leftNav.isCollapsed);
    const searchedMultiResults = useSelector(state => state.search.searchedMultiResults);
    const highlightName = useSelector(state => state.map.highlightName);
    const multiCoordinates = useSelector(state => state.map.multicoordinates)
    const [selectedFields, setSelectedFields] = useState({});


    const closeSearchView = () => {
        dispatch(resetAllCollections());
        dispatch(searchActions.setInnerActiveKey(null));
        dispatch(searchActions.resetMultiStacData());
        dispatch(mapActions.resetDisplayView());
        dispatch(mapActions.resetMultiSearchView());
        dispatch(mapActions.resetHighlightAOI());
        dispatch(mapActions.resetMultiAOICoordinates());

    };

    // const highlightAOi = (name) => {
    //     if (highlightName === name) {
    //         dispatch(mapActions.resetHighlightAOI());
    //     } else {
    //         dispatch(mapActions.setHighlightAOI(name));
    //     }
    // };

    const handleDropdownChange = (resultName, selected) => {
        setSelectedFields(prev => ({
            ...prev,
            [resultName]: selected
        }));
    };

    const handlePrivateerCall = () => {
        dispatch(getDraftOrders(multiCoordinates, redirectToprivateer));
    }

    const redirectToprivateer = () => {
        window.open(PRIVATEER_REDIRECT_URL, "_blank");
        closeSearchView();
    }


    return (
        <>
            <div className={`orderDescriptionBox searchDetails ${isLeftNavCollapsed ? 'collapsed' : ''}`}>
                <div className="search-results-header bottomBorder">
                    <div className="search-results-title">
                        Analysis Results
                    </div>
                    <div className="search-header-actions">
                        <button className="icon-button" onClick={() => setIsModalMinimized(!isModalMinimized)}>
                            {!isModalMinimized && <MinimizeIcon />}
                            {isModalMinimized && <MaximizeIcon />}
                        </button>
                        <button className="icon-button" onClick={closeSearchView}>
                            <Close />
                        </button>
                    </div>
                </div>
                {!isModalMinimized && (
                    <>
                        <div className="search-results-body enhanced-results">
                            {searchedMultiResults.length === 0 ? (
                                <div className="no-results">No results yet.</div>
                            ) : (
                                <div className="result-cards">
                                    {searchedMultiResults.map((result, index) => (
                                        <div
                                            key={index}
                                            className={`result-card ${highlightName === result.name ? 'selected' : ''}`}
                                        >
                                            <div className="result-name">{result.name}</div>
                                            <SingleSelectDropdown
                                                options={analysisOptions}
                                                onSelectItemChange={(item) => handleDropdownChange(result.name, item)}
                                                keyName="propertyID"
                                                valueName="name"
                                                selectedValue={selectedFields[result.name] || null}
                                                dropdownName="field"
                                                placeholder="Property"
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className='analysis-btn' onClick={() => {handlePrivateerCall()}}>
                        Run Analysis
                        </div>
                    </>
                )}

            </div>
            <Timeline />
        </>
    )
}

export default MultiSearchView